<!--
 * @Autor:
 * @Date: 2024-11-07 10:29:33
 * @LastEditTime: 2024-11-07 11:32:14
 * @Description:
 * @FilePath: \register\src\components\formMessage.vue
-->
<template>
  <div class="note" :class="{ 'note-normal': showTips, 'note-wrong': showError, 'note-right': showRight }">
    <span>{{ msg }}&nbsp;</span>
  </div>
</template>

<script>
export default {
  props: {
    prop: String,
  },
  inject: ['root'],
  data() {
    return {
      msg: '',
      showError: false,
      showRight: false,
      showTips: false
    };
  },
  mounted() {
    this.root.formMessageRefs.push(this);
  },
  methods: {
    initalize() {
      this.showError = false;
      this.showRight = false;
      this.showTips = false;
    },
    showMessage(params) {
      this.initalize();
      const { message, type } = params;
      const msg = type === 'success' ? '' : message;
      this.msg = msg;
      if (type === 'success') this.showRight = true;
      else if (type === 'warn') this.showError = true;
      else this.showTips = true;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/formMessage.vue